import { CategoryType } from "enums";
import { CategoryModel, ItemSearchOptions } from "models";
import React from "react";
import { AiOutlineDown, AiOutlineRight } from "react-icons/ai";

type PROPS = {
  options: ItemSearchOptions;
  category?: CategoryModel;
  onSelect: (target: CategoryModel) => void;
};

const ItemListSideMenuTreeNode: React.FC<PROPS> = (props) => {
  const cache = React.useRef<CategoryModel>();
  const [active, setActive] = React.useState(false);
  const [hasList, setHasList] = React.useState(false);
  const [opened, setOpened] = React.useState(false);

  const onChange = () => {
    const status = !opened;
    setOpened(status);

    if (props.category) {
      props.onSelect(props.category);
    }
  };

  React.useEffect(() => {
    if (!props.category) {
      setActive(false);
      setHasList(false);
      setOpened(false);
      cache.current = undefined;
    } else {
      const id = props.category.id;
      const active =
        id === props.options.item_large_category_id ||
        id === props.options.item_medium_category_id ||
        id === props.options.item_small_category_id;
      setActive(active);

      const hasList = props.category.list && props.category.list.length > 0;
      setHasList(hasList);
      if (!hasList) {
        // 子要素がなければ常にとじる
        setOpened(false);
      } else {
        if (props.category.type === CategoryType.LARGE) {
          // 大項目は常にひらく
          setOpened(true);
        } else if (props.category.type === CategoryType.MIDDLE) {
          if (props.options.item_medium_category_id && props.category.id !== props.options.item_medium_category_id) {
            setOpened(false);
          } else if (props.category !== cache.current && props.category.id === props.options.item_medium_category_id) {
            setOpened(true);
          }
        }
      }

      cache.current = props.category;
    }
  }, [
    opened,
    props.category,
    props.options.item_large_category_id,
    props.options.item_medium_category_id,
    props.options.item_small_category_id,
  ]);

  if (!props.category) {
    return (
      <div>
        <div className="flex items-center cursor-pointer" onClick={onChange}>
          <AiOutlineRight className="invisible" />

          <div className={`ml-2 font-bold`}>すべて</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center cursor-pointer" onClick={onChange}>
        {props.category.type !== CategoryType.LARGE && hasList ? (
          opened ? (
            <AiOutlineDown />
          ) : (
            <AiOutlineRight />
          )
        ) : (
          <AiOutlineRight className="invisible" />
        )}
        <div className={`ml-2 ${active && "font-bold"} hover:font-bold`}>{props.category.name}</div>
      </div>
      {opened && hasList && (
        <div className="m-4 flex flex-col gap-4">
          {props.category.list.map((item, index) => {
            return <ItemListSideMenuTreeNode key={index} options={props.options} category={item} onSelect={props.onSelect} />;
          })}
        </div>
      )}
    </div>
  );
};

export default ItemListSideMenuTreeNode;
